var validation_JOI_VALIDATIONS_FIELDS = /*#__PURE__*/ function(JOI_VALIDATIONS_FIELDS) {
    JOI_VALIDATIONS_FIELDS["emptyString"] = "string.empty";
    JOI_VALIDATIONS_FIELDS["minString"] = "string.min";
    JOI_VALIDATIONS_FIELDS["maxString"] = "string.max";
    JOI_VALIDATIONS_FIELDS["patternString"] = "string.pattern.base";
    return JOI_VALIDATIONS_FIELDS;
}({});
const organizationNameRegexp = /^[a-z0-9_-]+$/;
const organizationDisplayNameRegexp = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_.\-@']+( [a-zA-Z0-9_.\-@']+)*$/;
const profileNameRegexp = /^(?=[\x20-\x7F]+$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9_.\-@']+(\s[a-zA-Z0-9_.\-@']+)*\s*$/;
const teamNameRegexp = /^(?=[\x20-\x7F]+$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9_\-']+(\s[a-zA-Z0-9_\-']+)*\s*$/;
const projectNameRegexp = /^(?=[\x20-\x7F]+$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9_\-']+(\s[a-zA-Z0-9_\-']+)*\s*$/;
const projectDisplayNameRegexp = /^(?=[\x20-\x7F]+$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9_.\-@']+(\s[a-zA-Z0-9_.\-@']+)*\s*$/;
const applicationNameRegexp = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$/;
const applicationTagNameRegexp = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$/;
const applicationEnvironmentNameRegexp = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$/;
const applicationTagConditionValue = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_/. ^~><=|-]+$/;
const gitTagRegExp = /^(\/.*\/|[a-zA-Z0-9][-_./a-zA-Z0-9]*\*)$/;
const domainsRegexp = /^@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
const domainsStringWithComaSeparator = /^\s*(?:(?:\w+(?:-+\w+)*\.)+[a-z]+)\s*(?:\s*(?:(?:\w+(?:-+\w+)*\.)+[a-z]+)\s*)*$/;
const asciiStringRegexp = /^[\x00-\x7F]+$/;
const urlWithoutPathnameRegexp = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?::\d{1,5})?$/;
const integrationNameRegexp = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$/;
const APPLICATION_VERSION_FIELD_VALIDATION_REGEXP = {
    minLength: 3,
    maxLength: 15,
    pattern: /^(?=[\x20-\x7F]+$)([0-9]\d*\.){2}[0-9]\d*$/
};
const APPLICATION_CONDITION_FIELD_VALIDATION_REGEXP = {
    minLength: 3,
    maxLength: 100,
    pattern: applicationTagConditionValue
};
const APPLICATION_DNS_FIELD_VALIDATION_REGEXP = {
    minLength: 3,
    maxLength: 500,
    pattern: domainsStringWithComaSeparator
};
const APPLICATION_GIT_TAG_FIELD_VALIDATION_REGEXP = {
    minLength: 1,
    maxLength: 100,
    pattern: gitTagRegExp
};
const APPLICATION_REGEX_PATTERN_VALIDATION_REGEXP = {
    minLength: 1,
    maxLength: 100
};
const ORGANIZATION_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "The lowercased letters, numbers, underscores and dashes are available"
};
const ORGANIZATION_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 30,
        message: "This field is too long"
    },
    pattern: {
        value: organizationNameRegexp,
        message: "The lowercased letters, numbers, underscores and dashes are available"
    }
};
const ORGANIZATION_DOMAIN_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 50,
        message: "This field is too long"
    },
    pattern: {
        value: domainsRegexp,
        message: "Please enter a valid domain, such as @example.com"
    }
};
const ORGANIZATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
};
const ORGANIZATION_DISPLAY_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 50,
        message: "This field is too long"
    },
    pattern: {
        value: organizationDisplayNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const APPLICATION_CONDITION_TEXT_VALUE = {
    required: "This field is required",
    minLength: {
        value: APPLICATION_CONDITION_FIELD_VALIDATION_REGEXP.minLength,
        message: "This field is too short "
    },
    maxLength: {
        value: APPLICATION_CONDITION_FIELD_VALIDATION_REGEXP.maxLength,
        message: "This field is too long"
    },
    pattern: {
        value: APPLICATION_CONDITION_FIELD_VALIDATION_REGEXP.pattern,
        message: "Only the letters, numbers, underscores, dashes, are available"
    }
};
const TEAM_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
};
const TEAM_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 30,
        message: "This field is too long"
    },
    pattern: {
        value: teamNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const PROJECT_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
};
const PROJECT_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 30,
        message: "This field is too long"
    },
    pattern: {
        value: projectNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const PROJECT_DISPLAY_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 50,
        message: "This field is too long"
    },
    pattern: {
        value: projectDisplayNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const APPLICATION_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only the letters, numbers, underscores, dashes, are available"
};
const APPLICATION_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 30,
        message: "This field is too long"
    },
    pattern: {
        value: applicationNameRegexp,
        message: "Only the letters, numbers, underscores, dashes, are available"
    }
};
const APPLICATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
};
const APPLICATION_DISPLAY_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 30,
        message: "This field is too long"
    },
    pattern: {
        value: projectDisplayNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const APPLICATION_ENVIRONMENT_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only the letters, numbers, underscores, dashes, are available"
};
const APPLICATION_ENVIRONMENT_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 200,
        message: "This field is too long"
    },
    pattern: {
        value: applicationEnvironmentNameRegexp,
        message: "Only the letters, numbers, underscores, dashes, are available"
    }
};
const APPLICATION_TAG_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only the letters, numbers, underscores, dashes, are available"
};
const APPLICATION_TAG_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 200,
        message: "This field is too long"
    },
    pattern: {
        value: applicationTagNameRegexp,
        message: "Only the letters, numbers, underscores, dashes, are available"
    }
};
const APPLICATION_CONDITION_FIELD_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only the letters, numbers, underscores, dashes, are available"
};
const APPLICATION_GIT_TAG_FIELD_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Enter a valid git tag or regex pattern enclosed in forward slashes (e.g., v1.0.0 or /^v\\d+\\.\\d+\\.\\d+$/)"
};
const APPLICATION_REGEX_PATTERN_FIELD_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Invalid regex pattern"
};
const APPLICATION_DNS_FIELD_JOI_VALIDATION_MESSAGES = {
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only domains and subdomains are available"
};
const APPLICATION_GIT_TAG_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 1,
        message: "This field is too short "
    },
    maxLength: {
        value: 100,
        message: "This field is too long"
    },
    pattern: {
        value: gitTagRegExp,
        message: "Enter a valid git tag or regex pattern enclosed in forward slashes (e.g., v1.0.0 or /^v\\d+\\.\\d+\\.\\d+$/)"
    }
};
const requiredFieldJoiErrorMessage = {
    'any.required': "This field is required",
    'object.base': "This field is required"
};
const validationErrorMessagesDescriptionField = {
    'string.empty': "The description cannot be empty",
    'string.min': "Description is too short",
    'string.max': "Description is too long"
};
const PROFILE_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 75,
        message: "This field is too long"
    },
    pattern: {
        value: profileNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const PROFILE_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only the letters, numbers, underscores, dashes, are available"
};
const DESCRIPTION_VALIDATOR = {
    maxLength: {
        value: 200,
        message: "This field is too long"
    },
    pattern: {
        value: asciiStringRegexp,
        message: "Character should be in the valid ASCII range"
    }
};
const USERNAME_VALIDATOR = {
    maxLength: {
        value: 75,
        message: "This field is too long"
    },
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    pattern: {
        value: profileNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const EMAIL_VALIDATOR = {
    pattern: {
        value: /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/,
        message: "Please enter the valid email"
    }
};
const DESCRIPTION_JOI_VALIDATOR_MESSAGES = {
    'string.max': DESCRIPTION_VALIDATOR.maxLength.message,
    'string.pattern.base': DESCRIPTION_VALIDATOR.pattern.message
};
const EMAIL_JOI_VALIDATOR_MESSAGES = {
    'any.required': "This field is required",
    'string.email': "Please enter the valid email"
};
const LINKS_JOI_VALIDATOR_MESSAGES = {
    'string.uri': "Please enter the valid link"
};
const URL_STRING_JOI_VALIDATION_MESSAGES = {
    'string.empty': "This field is required",
    'string.uri': "Please enter the valid link",
    'string.pattern.base': "Please enter URL, not PathName"
};
const URL_STRING_VALIDATOR = {
    pattern: urlWithoutPathnameRegexp,
    message: "Please enter URL, not PathName"
};
const DEPLOY_INTEGRATION_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 75,
        message: "This field is too long"
    },
    pattern: {
        value: integrationNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const DEPLOY_INTEGRATION_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only the letters, numbers, underscores, dashes, are available"
};
const PROVIDER_JOI_VALIDATOR = {
    required: "This field is required",
    maxLength: {
        value: 75,
        message: "This field is too long"
    },
    minLength: {
        value: 3,
        message: "This field is too short "
    }
};
const USER_TOKEN_NAME_VALIDATOR = {
    required: "This field is required",
    minLength: {
        value: 3,
        message: "This field is too short "
    },
    maxLength: {
        value: 75,
        message: "This field is too long"
    },
    pattern: {
        value: profileNameRegexp,
        message: "The letters, numbers, underscores, dashes, spaces and apostrophes are available"
    }
};
const USER_TOKEN_NAME_JOI_VALIDATOR_MESSAGES = {
    'string.empty': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long",
    'string.pattern.base': "Only the letters, numbers, underscores, dashes, are available"
};
const validationErrorGeneralStringMessagesField = {
    'string.required': "This field is required",
    'string.min': "This field is too short ",
    'string.max': "This field is too long"
};
export { APPLICATION_CONDITION_FIELD_JOI_VALIDATOR_MESSAGES, APPLICATION_CONDITION_FIELD_VALIDATION_REGEXP, APPLICATION_CONDITION_TEXT_VALUE, APPLICATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES, APPLICATION_DISPLAY_NAME_VALIDATOR, APPLICATION_DNS_FIELD_JOI_VALIDATION_MESSAGES, APPLICATION_DNS_FIELD_VALIDATION_REGEXP, APPLICATION_ENVIRONMENT_NAME_JOI_VALIDATOR_MESSAGES, APPLICATION_ENVIRONMENT_NAME_VALIDATOR, APPLICATION_GIT_TAG_FIELD_JOI_VALIDATOR_MESSAGES, APPLICATION_GIT_TAG_FIELD_VALIDATION_REGEXP, APPLICATION_GIT_TAG_VALIDATOR, APPLICATION_NAME_JOI_VALIDATOR_MESSAGES, APPLICATION_NAME_VALIDATOR, APPLICATION_REGEX_PATTERN_FIELD_JOI_VALIDATOR_MESSAGES, APPLICATION_REGEX_PATTERN_VALIDATION_REGEXP, APPLICATION_TAG_NAME_JOI_VALIDATOR_MESSAGES, APPLICATION_TAG_NAME_VALIDATOR, APPLICATION_VERSION_FIELD_VALIDATION_REGEXP, DEPLOY_INTEGRATION_NAME_JOI_VALIDATOR_MESSAGES, DEPLOY_INTEGRATION_NAME_VALIDATOR, DESCRIPTION_JOI_VALIDATOR_MESSAGES, DESCRIPTION_VALIDATOR, EMAIL_JOI_VALIDATOR_MESSAGES, EMAIL_VALIDATOR, validation_JOI_VALIDATIONS_FIELDS as JOI_VALIDATIONS_FIELDS, LINKS_JOI_VALIDATOR_MESSAGES, ORGANIZATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES, ORGANIZATION_DISPLAY_NAME_VALIDATOR, ORGANIZATION_DOMAIN_VALIDATOR, ORGANIZATION_NAME_JOI_VALIDATOR_MESSAGES, ORGANIZATION_NAME_VALIDATOR, PROFILE_NAME_JOI_VALIDATOR_MESSAGES, PROFILE_NAME_VALIDATOR, PROJECT_DISPLAY_NAME_VALIDATOR, PROJECT_NAME_JOI_VALIDATOR_MESSAGES, PROJECT_NAME_VALIDATOR, PROVIDER_JOI_VALIDATOR, TEAM_NAME_JOI_VALIDATOR_MESSAGES, TEAM_NAME_VALIDATOR, URL_STRING_JOI_VALIDATION_MESSAGES, URL_STRING_VALIDATOR, USERNAME_VALIDATOR, USER_TOKEN_NAME_JOI_VALIDATOR_MESSAGES, USER_TOKEN_NAME_VALIDATOR, requiredFieldJoiErrorMessage, validationErrorGeneralStringMessagesField, validationErrorMessagesDescriptionField };
